import React, {useEffect, useState} from 'react';
import {connect} from "react-redux";
import {Link, NavLink} from "react-router-dom";
import useOnClickOutSide from "../../components/Hooks/useClickOutside";
import './menuBar.css';
import Hamburger from "./hamburger";
import './header.css';
import Logo from "../../../assets/img/deccanLogicLogo.jpg";
import {withTranslation} from "react-i18next";


function Header(props) {
    const [openSideMenuBar, setOpenSideMenuBar] = useState(false);
    const {isMobileView} = props;

    window.onscroll = function () {scrollFunction()};
    function scrollFunction() {
        if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
            document.getElementById("header").style.borderBottom = "0.50px solid #1671DD";
        } else {
            document.getElementById("header").style.borderBottom = "none";
        }
    }

    const handleHamburgerClick = () => {
        setOpenSideMenuBar(!openSideMenuBar);
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const renderUI = () => {
        if (isMobileView) {
            return (
                <div className="d-flex align-items-center justify-content-between block-container h-100 w-100">
                    <div>
                        <Link to='/'>
                            <img src={Logo}
                                 height={29}
                                 style={{marginLeft: -10}}
                                 alt="DeccanLogic"/>
                        </Link>
                    </div>
                    <div>
                        <i className="fa-solid fa-bars"
                           style={{fontSize: 16, cursor: 'pointer'}}
                           onClick={handleHamburgerClick}/>
                    </div>
                    {openSideMenuBar &&
                        <div className='bg-white w-100 d-flex justify-content-end h-100'>
                            <Hamburger {...props}
                                       handleHamburgerClick={handleHamburgerClick}
                                       useOnClickOutSide={useOnClickOutSide}
                            />
                        </div>
                    }
                </div>
            );
        }

        return (
            <nav className="nav">
                <div className="nav-inner d-flex align-items-center col-xl-12">
                    <div>
                        <Link to='/'>
                            <img src={Logo}
                                 style={{marginLeft: -10, width: '150px', height: '37px', marginBottom: '2px'}}
                                 alt="DeccanLogic"/>
                        </Link>
                    </div>
                    <div className="nav-links">
                        <NavLink exact to="/" activeClassName="active">Home</NavLink>
                        <NavLink to="/services/ai-capabilities" activeClassName="active">AI Capabilities</NavLink>
                        <NavLink to="/services/technology-partnership" activeClassName="active">Technology Partnership</NavLink>
                        <NavLink to="/services/custom-software-development" activeClassName="active">Custom Software Development</NavLink>
                    </div>
                    <Link to="/contact-us" className="nav-cta">Contact Us</Link>
                </div>
            </nav>
        );
    };

    return (
        <div id={'header'}
             className='w-100 theme-bg-white position-fixed top-0 content'
             style={{
                 zIndex: 999,
                 height: isMobileView ? 50 : 70,
                 filter: 'drop-shadow(0px 4px 10px rgba(0, 0, 0, 0.10))'
             }}>
            {renderUI()}
        </div>
    );
}

Header.propTypes = {};

Header.defaultProps = {};

const mapStateToProps = (state) => ({
    isMobileView: state.appState.deviceInfo.isMobileView,
    isLGView: state.appState.deviceInfo.isLGView,
    isXLView: state.appState.deviceInfo.isXLView,
    isXSView: state.appState.deviceInfo.isXSView,
    isSMView: state.appState.deviceInfo.isSMView,
});

export default connect(mapStateToProps, {})(withTranslation('translations')(Header));
